import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommandTemplate } from 'store/userOrg/userOrgApi';

type FilteredTemplatesType = (CommandTemplate | null | undefined)[] | undefined;
interface HPCApplicationsState {
    filterCommandTemplateName: string;
    filteredTemplates: FilteredTemplatesType;
}

const initialState: HPCApplicationsState = {
    filterCommandTemplateName: '',
    filteredTemplates: undefined,
};

const hpcApplicationsSlice = createSlice({
    name: 'hpcApplications',
    initialState,
    reducers: {
        setFilteredTemplates: (state, action: PayloadAction<FilteredTemplatesType>) => {
            state.filteredTemplates = action.payload;
        },
        resetFilteredTemplates: state => {
            state.filteredTemplates = undefined;
        },
        setFilterCommandTemplateName: (state, action: PayloadAction<string>) => {
            state.filterCommandTemplateName = action.payload;
        },
        resetFilterCommandTemplateName: state => {
            state.filterCommandTemplateName = '';
        },
    },
});

export const {
    resetFilterCommandTemplateName,
    setFilterCommandTemplateName,
    setFilteredTemplates,
    resetFilteredTemplates,
} = hpcApplicationsSlice.actions;

export default hpcApplicationsSlice.reducer;
